var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEventUpcoming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    viewBox: "0 -960 960 960",
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M773.334-80H610.666q-14.167 0-23.75-9.617t-9.583-23.833q0-14.216 9.583-23.716 9.583-9.5 23.75-9.5h162.668v-420.001H186.666v166.668q0 14.167-9.617 23.75t-23.833 9.583q-14.216 0-23.716-9.583-9.5-9.583-9.5-23.75v-346.668q0-27 19.833-46.833 19.833-19.834 46.833-19.834h56.667v-31.999q0-14.734 9.967-24.7Q263.267-880 278-880q15.017 0 25.175 9.967 10.158 9.966 10.158 24.7v31.999h333.334v-31.999q0-14.734 9.966-24.7Q666.6-880 681.333-880q15.017 0 25.175 9.967 10.159 9.966 10.159 24.7v31.999h56.667q27 0 46.833 19.834Q840-773.667 840-746.667v600.001q0 27-19.833 46.833T773.334-80ZM383-166.667H80q-14.167 0-23.75-9.617t-9.583-23.833q0-14.216 9.583-23.716 9.583-9.5 23.75-9.5h303l-86.333-87.334q-9-9.666-9.5-23.233t9.5-23.433Q306.333-377 320-377q13.667 0 23.333 9.667l144 144q10 10 10 23.333 0 13.333-10 23.333l-144 144q-9.666 9.667-23.166 9.834-13.5.166-23.5-9.834Q287-42.333 287-56q0-13.667 9.667-23.333L383-166.667ZM186.666-633.333h586.668v-113.334H186.666v113.334Zm0 0v-113.334 113.334Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventUpcoming);
export default __webpack_public_path__ + "static/media/event_upcoming.487e3cc3f1b8a099afdc886fbc2d8562.svg";
export { ForwardRef as ReactComponent };